import React, { useState, useEffect } from 'react';
import { SubmitQuiz } from '../../../../services/Staff/Staff';
import { toast } from 'react-toastify';

const QuizSection = ({ questions, courseId,fetchData }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [userAnswers, setUserAnswers] = useState([]);
  const [loading, setLoading] = useState(false);

  const currentQuestion = questions[currentQuestionIndex];
  const { correctOption, options, answer: submittedAnswer, viewMode: isViewMode } = currentQuestion;

  useEffect(() => {
    if (isViewMode) {
      const savedAnswer = submittedAnswer;
      const optionIndex = options.indexOf(savedAnswer);
      setSelectedOption(optionIndex);
    } else {
      const savedAnswer = userAnswers[currentQuestionIndex]?.answer;
      const optionIndex = savedAnswer !== undefined ? options.indexOf(savedAnswer) : null;
      setSelectedOption(optionIndex);
    }
  }, [currentQuestionIndex, questions]);

  const handleOptionSelect = (index) => {
    if (isViewMode) return;

    setSelectedOption(index);
    const updatedAnswers = [...userAnswers];
    updatedAnswers[currentQuestionIndex] = {
      quizId: currentQuestion._id,
      answer: options[index],
    };
    console.log("lfhafd",updatedAnswers,questions)
    setUserAnswers(updatedAnswers);
  };

  const handleBack = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex((prev) => prev + 1);
    }
  };

  const handleSubmit = async () => {
    const payload = {
      courseId,
      quizes: userAnswers,
    };

    setLoading(true);
    try {
      const response = await SubmitQuiz(payload);
      if (response?.success) {
        toast.success(response.message);
        fetchData()
      }
    } catch (error) {
      console.error('Error submitting quiz:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h4 className="mb-2 ps-2">Quiz</h4>
      <div className="quiz-container pb-5">
        <div className="quiz-pagination mb-4">
          {questions.map((_, index) => (
            <div
              key={index}
              className={`dot ${currentQuestionIndex === index ? 'active' : ''}`}
            ></div>
          ))}
        </div>

        <h5 className="mb-4 quiz-question">{currentQuestion.question}</h5>

        {options.map((option, index) => {
          const isSelected = selectedOption === index;
          const isCorrect = option === correctOption;
          const userAnswer = isViewMode ? submittedAnswer : userAnswers[currentQuestionIndex]?.answer;
          const isUserAnswer = option === userAnswer;
          const userWasWrong = isViewMode && userAnswer !== correctOption;

          let optionClass = '';
          if (isViewMode) {
            if (isCorrect) {
              optionClass = 'correct-answer'; // green
            } else if (isUserAnswer && !isCorrect) {
              optionClass = 'wrong-answer'; // red
            }
          } else if (isSelected) {
            optionClass = 'custom-border';
          }

          return (
            <div
              key={index}
              className={`quiz-option ${optionClass}`}
              onClick={() => handleOptionSelect(index)}
            >
              <input
                type="radio"
                name="quizOption"
                checked={isSelected}
                onChange={() => handleOptionSelect(index)}
                id={`option${index}`}
                disabled={isViewMode}
              />
              <label
                htmlFor={`option${index}`}
                className="ms-2 d-flex align-items-center flex-grow-1 justify-content-between"
              >
                <span>{option}</span>
                {isViewMode && (
                  <>
                    {isCorrect && (
                      <i className="bi bi-check-circle-fill text-success ms-2"></i>
                    )}
                    {!isCorrect && isUserAnswer && (
                      <i className="bi bi-x-circle-fill text-danger ms-2"></i>
                    )}
                  </>
                )}
              </label>
            </div>
          );
        })}

        <div className="d-flex justify-content-between mt-4">
          <button
            className="custom-quiz-btn"
            onClick={handleBack}
            disabled={currentQuestionIndex === 0}
          >
            Back
          </button>

          {isViewMode ? (
            <button
              className="custom-quiz-btn"
              onClick={handleNext}
              disabled={currentQuestionIndex === questions.length - 1}
            >
              Next
            </button>
          ) : currentQuestionIndex === questions.length - 1 ? (
            <button
              className="custom-quiz-btn"
              onClick={handleSubmit}
              disabled={selectedOption === null || loading}
            >
              {loading ? 'loading...' : 'Submit'}
            </button>
          ) : (
            <button
              className="custom-quiz-btn"
              onClick={handleNext}
              disabled={selectedOption === null}
            >
              Next
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default QuizSection;
